import {ValidationError} from 'src/contexts/validation-context/validation-context';

export const validateEndDate = (
    endDate: string | undefined, startDate: string | undefined, controlId: string,
): ValidationError | null => {
    if (endDate && startDate && endDate < startDate) {
        return {
            message: 'End date cannot be before start date',
            code: 'INVALID_DATE_RANGE',
            controlId,
        };
    }
    return null;
};

export const isValidDateRange = (
    endDate: string | undefined, startDate: string | undefined,
): boolean => {
    return !!(startDate && endDate && endDate >= startDate);
};
